import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { ToastContainer, notify } from '../../libraries/notifications';
import appointmentsActions from "../../context/appointments/actions";
import { OTSession, OTPublisher, OTStreams, OTSubscriber } from 'opentok-react';
import { history } from "../../routes";

import config from "../../config";

import Information from "../commons/Information";

import LayoutSmall from "../../components/layout/LayoutSmall";
import Loader from "../../components/commons/Loader";
import ButtonIcon from "../../components/commons/ButtonIcon";


class Videocall extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      error: null,
      connection: 'Connecting',
      publishVideo: true,
      apiKey: config.OPENTOK_API_ID,
      sessionId: null,
      token: null,
    };


    this.sessionEventHandlers = {
      sessionConnected: () => {
        this.setState({ connection: 'Connected' });
      },
      sessionDisconnected: () => {
        this.setState({ connection: 'Disconnected' });
      },
      sessionReconnected: () => {
        this.setState({ connection: 'Reconnected' });
      },
      sessionReconnecting: () => {
        this.setState({ connection: 'Reconnecting' });
      },
    };

    this.publisherEventHandlers = {
      accessDenied: () => {
        console.log('User denied access to media source');
      },
      streamCreated: () => {
        console.log('Publisher stream created');
      },
      streamDestroyed: ({ reason }) => {
        console.log(`Publisher stream destroyed because: ${reason}`);
      },
    };

    this.subscriberEventHandlers = {

      audioEnabled : () => {
        console.log('Audio enabled');
      },
      audioDisabled : () => {
        console.log('Audio disabled');
      },

      videoEnabled: () => {
        console.log('Subscriber video enabled');
      },
      videoDisabled: () => {
        console.log('Subscriber video disabled');
      },
    };
    
  }

  toggleAudio = () => {
    this.setState(state => ({
      publishAudio: !state.publishAudio
    }))
  }

  toggleVideo = () => {
    this.setState(state => ({
      publishVideo: !state.publishVideo,
    }));
  }

  componentDidMount() {
    const params = this.props.match.params;
    console.log("MY WASH", params);
    if (params.id) {
      this.getAppointments(params.id);
    } else {
      history.push(config.ROUTES.APPOINTMENTS.LIST);
    }
  }


  getAppointments = async (id) => {
    await this.props.onGet(id);
    const { appointment } = this.props;
    if (appointment.error) {
      notify(this.t(appointment.error.message));
    } else {
      this.setState({ appointment: appointment.item, sessionId: appointment.item.json_data.professional.bio, token: appointment.item.json_data.video_token });
      console.log("session___token", this.state.token,this.state.sessionId)
    }
  };

  
  
  updateStatus = async () => {
    const payload = {
      id: this.state.appointment.id,
      //TODO: usuario debería poder finalizar consulta?
      //status: config.TRANSACTIONS.BOOK.STATUS.COMPLETED,
    }
    await this.props.onSaveOrUpdate(payload);
    console.log('AFTER UPDATE');
    const error = this.props.appointment.error;
    if (error) {
      notify(this.t(error.message));
    } 
  };

  onContinue = async () => {
    await this.updateStatus()
    history.push({
      pathname: config.ROUTES.APPOINTMENTS.SUCCESS.replace(':id', this.state.appointment.id),
      state: {
        title: "Consulta finalizada con éxito",
        button:{
          text: "Volver a consultas",
          route: config.ROUTES.APPOINTMENTS.LIST,
        },
        button2:{
          text: "Home",
          route: config.ROUTES.HOME,
        }
      }
    })
  }

  render() {
    const { error, connection, publishVideo, publishAudio, apiKey, sessionId, token } = this.state;

    return (
      <div>
      {sessionId, token && <>
        <OTSession
          apiKey={apiKey}
          properties={{position: 'relative', width: '100%', height: '100%'}}
          sessionId={sessionId}
          token={token}
          onError={this.onSessionError}
          eventHandlers={this.sessionEventHandlers}
        > 
          {/*ESTE ES EL PACIENTE TIENE QUE IR CHIQUITO*/}
          <OTPublisher
            properties={{ publishVideo, width: '100px', height: '150px', position: "absolute"}}
            onPublish={this.onPublish}
            onError={this.onPublishError}
            eventHandlers={this.publisherEventHandlers}
          />
          <OTStreams>
            <OTSubscriber
              properties={{width: '100%', height: '100vh', position: 'relative' }}
              onSubscribe={this.onSubscribe}
              onError={this.onSubscribeError}
              eventHandlers={this.subscriberEventHandlers}
            />

          </OTStreams>

          <small id="sessionStatus" className="fixed top-1 left-1 text-white" style={{zIndex: 150}}>Session Status: {connection}</small>

          <div className="fixed bottom-3 left-2 right-2 flex justify-center gap-3 mr-28" style={{zIndex: 150}}>
          <ButtonIcon
              onClick={this.toggleVideo}
              title={publishVideo ? 'disable video' : 'enable video'}
              buttonClassName={publishVideo ? 'btn-lg btn-circle' : 'btn-lg btn-circle btn-ghost text-white text-opacity-50'}
              icon="video_camera"
              className="w-6 h-6"

            />
            <ButtonIcon
              onClick={this.toggleAudio}
              title={publishAudio ? 'disable audio' : 'enable audio'}
              buttonClassName={publishAudio ? 'btn-lg btn-circle' : 'btn-lg btn-circle btn-ghost text-white text-opacity-50'}
              icon="microphone"
              className="w-6 h-6"
            />
            <ButtonIcon
              buttonClassName="btn-error btn-circle btn-lg"
              onClick={this.onContinue}
              icon="phone_missed_call"
              className="w-6 h-6"
            />
          </div>

        </OTSession>
        </>}
      </div>

    )

  }
}
const mapStateToProps = (state) => {
  return {
    auth: state.users.auth,
    appointment: state.appointments.current,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGet: (params) => dispatch(appointmentsActions.get(params)),
    onSaveOrUpdate: (params) => dispatch(appointmentsActions.saveOrUpdate(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Videocall));
